import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { GetPermissionInfoStatus, RecipientPermissionInfo } from 'owa-sharing-data';
import { SharingDialogResponse } from 'owa-sharing-dialog';
import { action } from 'satcheljs';

// This action uses the word SharePoint while the rest of the package uses sharing because GetSharingInfo is
// SharePoint specific, so adding a SharePointLink will be a different process than adding an ODC/GDrive link.
// For the rest of the package it shouldn't matter where the link came from, so the more generic term 'sharing' is used.
// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const addSharePointLink = action(
    'ADD_SHAREPOINT_LINK',
    (linkId: string, url: string, sharingLinkIds: string[], response: GetSharingInfoResponse) => ({
        linkId: linkId,
        url: url,
        sharingLinkIds: sharingLinkIds,
        response: response,
    })
);

// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const removeSharingLink = action(
    'REMOVE_SHARING_LINK',
    (linkId: string, sharingLinkIds: string[]) => ({
        linkId: linkId,
        sharingLinkIds: sharingLinkIds,
    })
);

export const updateSharingLinkFromSharingDialog = action(
    'UPDATE_SHARING_LINK_FROM_SHARING_DIALOG',
    (linkId: string, sharingDialogResponse: SharingDialogResponse) => ({
        linkId: linkId,
        sharingDialogResponse: sharingDialogResponse,
    })
);

export const updateSharePointLinkPermission = action(
    'UPDATE_SHAREPOINT_LINK_PERMISSION',
    (linkId: string, newPermission: AttachmentPermissionLevel) => ({
        linkId: linkId,
        newPermission: newPermission,
    })
);

export const updateSharePointLinkUrl = action(
    'UPDATE_SHAREPOINT_LINK_URL',
    (linkId: string, newLinkUrl: string, oldLinkUrl: string) => ({
        linkId: linkId,
        newLinkUrl: newLinkUrl,
        oldLinkUrl: oldLinkUrl,
    })
);

export const refreshSharingTipsForLink = action(
    'REFRESH_SHARING_TIPS_FOR_LINK',
    (linkId: string) => ({
        linkId: linkId,
    })
);

export const updateHasDLRecipient = action(
    'UPDATE_HAS_DL_RECIPIENT',
    (linkId: string, hasDLRecipient: boolean) => ({
        linkId: linkId,
        hasDLRecipient: hasDLRecipient,
    })
);
export const addRecipientsIntoLink = action(
    'ADD_RECIPIENTS_INTO_LINK',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);

export const updateRecipientPermissionInfo = action(
    'UPDATE_RECIPIENT_PERMISSION_INFO',
    (
        linkId: string,
        emailAddress: string,
        hasAccess: boolean,
        canHaveAccess: boolean,
        getPermissionInfoStatus: GetPermissionInfoStatus
    ) => ({
        linkId: linkId,
        emailAddress: emailAddress,
        hasAccess: hasAccess,
        canHaveAccess: canHaveAccess,
        getPermissionInfoStatus: getPermissionInfoStatus,
    })
);

export const removeRecipientsFromLink = action(
    'REMOVE_RECIPIENTS_FROM_LINK',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);
